import { useTranslation } from 'libs/i18n'
import { ContextMenu } from 'shared/components'
import { Detail } from 'shared/atoms'
import type { Option } from 'shared/components/ContextMenu/types'
import type { GenderItem } from '../../types/genders.types'

export type GenderProps = {
	gender: GenderItem
	menuOptions: Option[]
}

export const Gender = ({ gender, menuOptions }: GenderProps) => {
	const { t } = useTranslation()

	return (
		<li className="p-4">
			<div className="flex items-start justify-between gap-3">
				<p className="min-w-0 text-[13px] font-semibold text-foreground">{gender.name}</p>
				<ContextMenu
					dataId={gender.id}
					item={gender}
					options={menuOptions}
					label={t('Actions for {{ name }}', { name: gender.name })}
				/>
			</div>
			<dl className="mt-2 grid grid-cols-2 gap-x-4 gap-y-2 text-[11px]">
				<Detail label={t('Products')} value={gender.products_count} />
			</dl>
		</li>
	)
}
